import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { LoaderService } from '../../../app/services/loader.service';
import { AuthService } from '../../../app/services/auth.service';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { GigyaSessionService } from 'modules/app/services/gigya-session.service';
import { AppHelperService } from 'modules/app/services/app-helper.service';
import { ActivityViewHelperService } from "../../services/activity-view-helper.service";
import { ActivityViewDataService } from "../../services/activity-view-data.service";
import { ContentHelper } from 'libs-content-helper';
import { ApiGatewayHelperService } from 'modules/app/services/apigateway-helper.service';
import { ContentAccessHelperService } from 'modules/shared/services/content-access-helper.service';
import { TrackUserService } from './../../../shared/services/track-user.service';
import { appSetting } from 'config/appSettings';
import { Title } from "@angular/platform-browser";
import { TranslateService } from '@ngx-translate/core';
declare var $: any;

@Component({
    selector: 'product-view',
    templateUrl: './product-view.template.html',
    styleUrls: ['./product-view-base.style.scss', './product-view-primary.style.scss', './product-view-secondary.style.scss'],
    standalone: false
})
export class ProductView implements OnInit, OnDestroy, AfterViewInit {
  public contentHelper = ContentHelper;
  private spaceId: string;
  private classId: string;
  private scrollToItemCode;
  private topOffsetForScrolling = 16;
  private lastCompletedUnit;
  public bundleProduct: any;
  public showAssignmentOnlyComponentBanner: boolean = false;
  public serverTimeOffset: number = 0;

  public productCode: string;
  public isTeacher: Boolean = false;
  public productViewData: any;
  public userData: any;
  public backagroundImage: string = '';
  public scrollToUnitCode;
  public scrollToLessonCode;
  // these are code generated sequence numbers in front of unit and activity title
  public showUnitSequence = true;
  public showActivitySequence = true;
  // Object for bundle image url
  public bundleObject: any = {};
  msgBannerData: any;
  showBanner: boolean = false;
  folderId: string;
  unlockDetail: any = {};
  toc: any;
  // modal references
  @ViewChild('activityLockModal') activityLockModal : ElementRef;
  @ViewChild('activityLockModalCancel') activityLockModalCancel : ElementRef;
  @ViewChild('showActivityLockModal') showActivityLockModal : ElementRef;
  classEndDate: number;
  titleTextColor;
  public imagesBasePath: string = IMAGES_BASEPATH;
  
  constructor(
    private loaderService: LoaderService,
    private authService: AuthService,
    private gigyaSessionService: GigyaSessionService,
    private appHelperService: AppHelperService,
    private route: ActivatedRoute,
    private router: Router,
    public activityViewHelperService: ActivityViewHelperService,
    private activityViewDataService: ActivityViewDataService,
    private apiGatewayHelperService: ApiGatewayHelperService,
    private contentAccessHelperService: ContentAccessHelperService,
    private trackUserService: TrackUserService,
    private readonly titleService: Title,
    private translate: TranslateService,
  ) { }

  ngOnInit() {
    this.userData = this.authService.getUserData();
    this.route.params.subscribe((params: Params) => {
      this.spaceId = params.spaceId;
      this.productCode = params.productCode;
      this.classId = params.classId ? params.classId : '';
      this.folderId = params.folderId;
      this.productViewData = this.route.snapshot.data.productViewResolverData;
      this.toc = this.productViewData.toc;
      this.titleTextColor = this.productViewData.productDetails.meta.model.media_mast_head_text_color;
      this.bundleProduct = this.productViewData.bundleDetails.products.find(p => p['dls-product'] && p['dls-product'].code === this.productCode);
      const serverTime = this.productViewData.serverTime;
      const clientTime = Date.now();
      /** 
       * serverTimeOffset is the difference between server and client time, added to client time to keep time-based access 
       * accurate even if the user stays on the TOC page before launching content.
       **/
      this.serverTimeOffset = serverTime - clientTime;

      const key = appSetting.localStorage.assignmentOnlyComponentBanner(this.userData.extUserId)
      if (localStorage.getItem(key) !== "false" && this.bundleProduct.activation?.gated?.student?.["assignments-only"]) {
        this.showAssignmentOnlyComponentBanner = true;
      }

      if (this.router.url && this.router.url.indexOf("/teacher/") !== -1) {
        this.isTeacher = true;
      }
      if (this.productViewData.productDetails.meta && this.productViewData.productDetails.meta.model && this.productViewData.productDetails.meta.paths) {
        this.backagroundImage = this.createImageUrl(this.productViewData.productDetails.meta.model.media_mast_head_bg);
      }
      // bundle/product image & title
      this.bundleObject['image_url'] = this.createImageUrl(this.productViewData && this.productViewData.bundleDetails && this.productViewData.bundleDetails.image, true);
      this.bundleObject['productTitle'] = this.bundleProduct.meta.title;

      if (this.productViewData && this.productViewData.classDetails && this.productViewData.classDetails.class)
        this.classEndDate = this.productViewData.classDetails.class.enddate;

      // Initialize XAPI Analytics
      const routePrefix = this.apiGatewayHelperService.getApiGatewayPrefixUrl();
      const serverRoutePrefix = routePrefix.substr(0, routePrefix.length - 1);

      const xapiAnalyticsObj = {
        serverRoutePrefix: serverRoutePrefix,
        dlsProductCode: this.productCode,
        isTestTypeProduct: this.activityViewHelperService.getIsTestTypeProduct(),
        spaceId: this.spaceId,
        orgId: this.productViewData.toc.tocArray.orgId,
        dlsClassId: this.classId,
        isCBPClass: this.activityViewHelperService.getIsCBPClass(),
        userId: this.userData.extUserId,
        userProgressAnalytics: this.productViewData.toc.navigationMeta,
      };
      // Make classId undefined if Class is expired, so that the component behaves like it does with private learning
      if (this.productViewData && this.productViewData.classDetails && this.productViewData.classDetails.class
        && this.productViewData.classDetails.class.enddate && new Date(this.productViewData.classDetails.class.enddate) < new Date()) {
        delete xapiAnalyticsObj.dlsClassId;
      }
      this.activityViewHelperService.setXAPIAnalyticsObject(xapiAnalyticsObj);

      // First transform TOC data, then resume Toc State to have isUnitInCompleteState Flag on units
      this.transformProductViewData();

      this.resumeTOCState();

      this.titleService.setTitle(this.productViewData?.bundleDetails?.title + this.translate.instant("HTML_META.MAIN.CUSTOM_TITLE"));

      this.loaderService.hideLoader();
    });
    
    let showMsgBannerParam = this.route.snapshot.queryParams['showMessageBanner'];
    if (showMsgBannerParam === 'true') {
      this.msgBannerData = this.appHelperService.getBannerDataFromLocalStorage(this.userData.extUserId);
      if (this.msgBannerData) {
        this.showBanner = true;
        setTimeout(() => { this.showBanner = false; }, 10000);
      }
    }

    if (this.userData && this.userData.role === 'student' && this.userData.launchType !== 'lti') {
      try {
        // logging product viewed event
        const userData = {
          user: this.userData,
          productCode: this.productCode,
          classId: this.classId,
          spaceId: this.spaceId,
          page: this.trackUserService.CONSTANTS.NAVIGATED_PAGE_NAMES.NLP_TOC
        }
        const loginEvent = this.trackUserService.generateProductViewedEvent(userData);
        this.trackUserService.logEvents([loginEvent]);
      }
      catch (e) {
        // do nothing just logging
        console.log(e);
      }
    }

  }

  transformProductViewData() {
    if (this.productViewData.productDetails && this.productViewData.productDetails.meta && this.productViewData.productDetails.meta.model) {
      this.showUnitSequence = this.productViewData.productDetails.meta.model['app-hide-unit-number'] !== 'true';
      this.showActivitySequence = this.productViewData.productDetails.meta.model['app-hide-activity-sequencing'] !== 'true';
    }
    for (const unit of this.productViewData.toc.tocArray.result) {
      unit['image_url'] = this.createImageUrl(unit.model && unit.model.url);
      if (this.isTeacher && unit.items) {
        for (const lesson of unit.items) {
          lesson['image_url'] = this.createImageUrl(lesson.model && lesson.model.url);
        }
      }
      if (unit.__analytics && unit.items) {
        const unitStatus = {
          totalActivity: 0,
          completedActivityCount: 0,
          inProgressActivityCount: 0
        };
        for (const lesson of unit.items) {
          lesson['image_url'] = this.createImageUrl(lesson.model && lesson.model.url);
          if (lesson.__analytics && lesson.items) {
            const lessonStatus = {
              totalActivity: 0,
              completedActivityCount: 0,
              inProgressActivityCount: 0
            };

            for (const activity of lesson.items) {
              lessonStatus.totalActivity++;
              unitStatus.totalActivity++;
              if (this.activityViewHelperService.isThisActivityComplete(activity)) {
                lessonStatus.completedActivityCount++;
                unitStatus.completedActivityCount++;
                activity.__analytics.showActivityAsComplete = true;
              } else if (activity.__analytics.accessedOnce || activity.__analytics.submittedOnce) {
                lessonStatus.inProgressActivityCount++;
                unitStatus.inProgressActivityCount++;
              }
            }

            // Count of the total activities completed in a lesson (for active progress bar)
            lesson.__analytics.totalCompletedActivity = lessonStatus.completedActivityCount;

            if (lessonStatus.totalActivity !== 0 && lessonStatus.totalActivity === lessonStatus.completedActivityCount) {
              lesson.__analytics.lessonStatus = 'completed'; // lesson completed
            } else if (lessonStatus.inProgressActivityCount || lessonStatus.completedActivityCount) {
              lesson.__analytics.lessonStatus = 'in_progress'; // lesson in progress
            } else {
              lesson.__analytics.lessonStatus = 'not_started';
            }
          }
        }

        if (unitStatus.totalActivity !== 0 && unitStatus.totalActivity === unitStatus.completedActivityCount) {
          unit.__analytics.unitStatus = 'completed'; // unit completed
        } else if (unitStatus.inProgressActivityCount || unitStatus.completedActivityCount) {
          unit.__analytics.unitStatus = 'in_progress'; // unit in progress
        } else {
          unit.__analytics.unitStatus = 'not_started';
        }
        // Reset unit animation flag in appState, if unit becomes incomplete
        if (this.productViewData.appState && this.productViewData.appState.animatedUnitCompletion && this.productViewData.appState.animatedUnitCompletion[unit['item-code']]
          && unit.__analytics.unitStatus !== 'completed') {
          this.productViewData.appState.animatedUnitCompletion[unit['item-code']] = false;
          this.activityViewDataService.updateAppState(this.spaceId, this.productCode, this.productViewData.appState, this.classId).subscribe();
        }
      }
    }
  }

  resumeTOCState() {
    //NavigationArray : array containing all resources
    let navigationArray = this.productViewData.toc.navigationMeta;
    //Get the most recently accessed item stored in state API if user is not a teacher
    let recentlyAccessedItemCode = this.productViewData.appState && this.productViewData.appState.recentlyAccessedItem;

    if (navigationArray && navigationArray[0] && navigationArray[0]['item-code']) {
      // Expand first unit and first lesson, as default case
      const codes = navigationArray[0]['item-code'].split('/');
      this.scrollToUnitCode = codes[0];
      this.scrollToLessonCode = codes[0] + '/' + codes[1];
    }

    if (!this.isTeacher && recentlyAccessedItemCode) {
      //Find index of most recently accessed Item in NavigationArray
      const recentlyAccessedItemIndex = navigationArray.map((val) => val["item-code"]).indexOf(recentlyAccessedItemCode);
      // In case the product gets updated, the last stored recentlyAccessedItem is
      // no longer in the new product structure then open the first index item in the product which is set as default above
      if (recentlyAccessedItemIndex !== -1) {
        const codes = recentlyAccessedItemCode.split('/');
        // added folderId check here;
        let recentlyAccessedUnit;
        let recentlyAccessedLesson;
        // in case folderId is present, will need to prepend folderCode to unit and lesson.
        if (this.folderId) {
          recentlyAccessedUnit = this.productViewData.toc.tocObject[codes[0] + '/' + codes[1]];
          recentlyAccessedLesson = recentlyAccessedUnit['items'][codes[0] + '/' + codes[1] + '/' + codes[2]];
        } else {
          recentlyAccessedUnit = this.productViewData.toc.tocObject[codes[0]];
          recentlyAccessedLesson = recentlyAccessedUnit['items'][codes[0] + '/' + codes[1]];
        }
        const recentlyAccessedItem = recentlyAccessedLesson['items'][recentlyAccessedItemCode];
        // Check status of the LO
        if (recentlyAccessedItem.__analytics && recentlyAccessedItem.__analytics.status === 'completed') {
          const nextItem = navigationArray[recentlyAccessedItemIndex + 1];
          const nextItemCode = nextItem ? nextItem['item-code'] : '';
          const unitCodeOfNextItem = nextItemCode.split('/')[0];
          // Animate unit completion, if unit is complete and this unit has not been animated before
          if (this.activityViewHelperService.isThisUnitComplete(recentlyAccessedUnit['item-code'])
            && !(this.productViewData.appState.animatedUnitCompletion && this.productViewData.appState.animatedUnitCompletion[recentlyAccessedUnit['item-code']])) {
            this.lastCompletedUnit = recentlyAccessedUnit['item-code'];
            this.setScrollToCodes(recentlyAccessedItemCode, this.folderId); // This will expand the unit & Lesson
            return;
            // Go to next item if it is -
            //        recently accessed item was not last item
            //  AND   recently accessed item is not a downloadable
            //  AND   next item is from same unit
          } else if (recentlyAccessedItemIndex !== (navigationArray.length - 1) &&
            !this.contentHelper.isDownloadableContent(recentlyAccessedItem) &&
            unitCodeOfNextItem === recentlyAccessedUnit['item-code']) {
            this.setScrollToCodes(nextItemCode, this.folderId);
            return;
          }
        }
        // In all other cases, scroll to the recently accessed Item
        this.setScrollToCodes(recentlyAccessedItemCode, this.folderId);
      }
    }
  }

  ngAfterViewInit(): void {
    // Increase topOffsetForScrolling if cookie banner is visible
    const cookieBanner = document.getElementsByClassName('cookies-banner');
    if (cookieBanner && cookieBanner[0]) {
      this.topOffsetForScrolling += cookieBanner[0].clientHeight;
    }
    // Check for lastCompletedUnit field, if set, animate closing of concerned unit
    if (this.lastCompletedUnit) {
      this.animateUnitCompletion(this.lastCompletedUnit);
      // If last item code is valid,
      // It can be invalid, when user comes for first time, is teacher or item was deleted from builder
      // If invalid, Don't scroll anywhere, just show top of page
    } else if (this.scrollToItemCode) {
      this.scrollToItem(this.scrollToItemCode);
    }
  }

  public closeAssignmentOnlyComponentBanner(dontShowAgain: boolean = false) {
    const userid = this.userData.extUserId;
    if (dontShowAgain) localStorage.setItem(appSetting.localStorage.assignmentOnlyComponentBanner(userid), 'false');
    this.showAssignmentOnlyComponentBanner = false;
  }

  navigateToDashboard() {
    const { queryParams } = this.route.snapshot;
    if (queryParams.lf == 'ltd') {
      this.appHelperService.navigateToOnboardingApp(['lti-teacher-dashboard', this.spaceId, 'class', queryParams.cid, 'ltik', queryParams.ltik]);
    } else if(queryParams.lf == 'ltc') {
      this.appHelperService.navigateToOnboardingApp(['lti-component-selection', this.spaceId, 'class', queryParams.cid, 'bundle', queryParams.bcode, 'resource', queryParams.rcode, 'ltik', queryParams.ltik]);
    } else {
      this.appHelperService.navigateToDashboardApp([], { forceExit: true });
    }
  }

  launchItem(item, isCollab, groupId = '') {
    if (this.contentAccessHelperService.getContentAccessEnabled()) {
      const previousActivityState = item['accessInfo'].isLocked;
      this.contentAccessHelperService.setCurrentTime(this.serverTimeOffset + Date.now());

      const activeRule = this.contentAccessHelperService.getCurrentActiveRule(item.accessInfo.finalResultantLockDetails, item['item-code'], this.activityViewHelperService.getIsAssignmentOnlyProduct());
      item['accessInfo']['isLocked'] = activeRule.isLocked;
      this.unlockDetail = activeRule.unlockRuleDetails;

      // State change means increment or decrement child lock count
      if (item['accessInfo'].isLocked !== previousActivityState) {
        this.activityViewHelperService.updateParentChildLockCount(this.toc, item);
      }

      if (item['accessInfo'].isLocked) {
        this.showActivityLockModal.nativeElement.click();
        return;
      }
    }

    this.loaderService.showOverlayLoader();
    let requiredQueryParams = this.appHelperService.getRequiredQueryParams(this.route.snapshot.queryParams, ['lf', 'cid', 'bcode', 'rcode', 'ltik','b']);
    if (isCollab) {
      if (this.isTeacher && this.classId && groupId) {
        this.router.navigate(['item', item['item-code'], 'group-selection'], { relativeTo: this.route, queryParams: requiredQueryParams });
      }
      else {
        this.router.navigate(['view', 'item', item['item-code']], { relativeTo: this.route, queryParams: requiredQueryParams });
      }
    } else {
      this.router.navigate(['view', 'item', item['item-code']], { relativeTo: this.route, queryParams: requiredQueryParams });
    }
  }

  // Set unit, lesson and item codes for expanding them in HTML template
  setScrollToCodes(itemCode, folderId?) {
    const codes = itemCode.split('/');
    // in case folderId is present, will need to prepend folderCode to unit and lesson
    if (folderId) {
      this.scrollToUnitCode = codes[0] + '/' + codes[1];
      this.scrollToLessonCode = codes[0] + '/' + codes[1] + '/' + codes[2];
    } else {
      this.scrollToUnitCode = codes[0];
      this.scrollToLessonCode = codes[0] + '/' + codes[1];
    }
    this.scrollToItemCode = itemCode;
  }

  // This method only scrolls to LO, expansion of unit & lesson is handled in html template
  scrollToItem(itemCode) {
    setTimeout(() => {
      const activityAnchor = document.getElementById('lo-' + itemCode);
      $('html,body').animate({ scrollTop: $(activityAnchor).offset().top - this.topOffsetForScrolling }, 1500);
    });
  }

  // This method only scrolls to unit and closes it, pre-expansion is handled in html template
  animateUnitCompletion(unitCode) {
    setTimeout(() => {
      const unitCover = document.getElementById('unitCover-' + unitCode);
      $('html, body').animate({ scrollTop: $(unitCover).offset().top - this.topOffsetForScrolling }, 1500, () => {
        unitCover.click();
      });
    });
    // Save unit completion animation done, save this in app state
    if (!this.productViewData.appState.animatedUnitCompletion) {
      this.productViewData.appState.animatedUnitCompletion = {};
    }
    this.productViewData.appState.animatedUnitCompletion[unitCode] = true;
    this.activityViewDataService.updateAppState(this.spaceId, this.productCode, this.productViewData.appState, this.classId).subscribe();
  }

  createImageUrl(imageUrl, productCoverImage = false) {
    if (imageUrl) {
      // if absolute url, return the url itself
      if (/(^https?:\/\/)|(^\/\/)/i.test(imageUrl)) {
        return imageUrl;
      }
      if (productCoverImage) {
        if (this.productViewData && this.productViewData.bundleDetails && this.productViewData.bundleDetails.attribs && this.productViewData.bundleDetails.attribs['cover-product-code']) {
          return `${this.productViewData.bundleDetails.path}/${this.productViewData.bundleDetails.attribs['cover-product-code']}/${imageUrl}`;
        }
        return `${this.productViewData.bundleDetails.path}/${this.productViewData.productDetails.meta.productcode}/${imageUrl}`; //fallback
      }
      // for product bg image, unit and lesson cover images
      return `${this.productViewData.productDetails.meta.paths['public-assets']}/${imageUrl}`;
    }
    return null;
  }

  // navigate teacher back to Class Materials page or My Library Bundle view page
  navigateBack() {
    const { queryParams } = this.route.snapshot;
    if (queryParams.lf == 'ltd') {
      this.appHelperService.navigateToOnboardingApp(['lti-teacher-dashboard', this.spaceId, 'class', queryParams.cid, 'ltik', queryParams.ltik]);
    } else if(queryParams.lf == 'ltc') {
      this.appHelperService.navigateToOnboardingApp(['lti-component-selection', this.spaceId, 'class', queryParams.cid, 'bundle', queryParams.bcode, 'resource', queryParams.rcode, 'ltik', queryParams.ltik]);
    }
    else if (this.classId) {
        this.appHelperService.navigateToClassApp(['teacher', this.spaceId, 'class', this.classId, 'view/materials'], { forceExit: true });
    }
    else {
      const bundleCode = this.productViewData.bundleDetails['bundle-code'];
      this.appHelperService.navigateToDashboardApp(['teacher', this.spaceId, 'bundle', bundleCode, 'view'], { forceExit: true });
    }
  }

  logOut() {
    // Auth Service Logout
    this.authService.logOut().toPromise().then(
      (res) => {
        if (res.success) {
          // Gigya Service Logout
          this.authService.clearUserdata();
          return this.gigyaSessionService.gigyaLogout();
        }
      }
    ).then(() => {
      // On Logout navigate to home page
      this.appHelperService.navigateToOnboardingApp(['home']);
    });
  }

  sanitizeHTML(html) {
    // Replace all HTML tags with ''
    // This regex is safe from catastrophic backtracking
    return html.replaceAll(/<\/?[\w\s="'./:;#?-]+>/gi, '');
  }

  ngOnDestroy() {
    // Close modal if showing on navigating
    if (this.activityLockModal.nativeElement.classList.contains('show')) {
      this.activityLockModalCancel.nativeElement.click();
    }
  }
}